import type { PageEvent } from '@noths/polaris-client-next-components';

/**
 * This is to add the page object immediately into datalayer before
 * the gtm.start tag fires
 */
export const getServerSidePageEventObject = (version: string, appVersion: string): PageEvent => ({
  page: {
    category: 'Join NOTHS - Partners',
    subcategory: 'Application Form',
    environment: process.env.NODE_ENV,
    react: 'true',
    release_version: version,
    app_version: appVersion,
  },
});
